import React, {Component} from 'react';
import { Col, Row, Tabs,Tab,  FormControl} from 'react-bootstrap';
import FileDownload from 'shared/FileDownload';
import moment   from 'moment'
 import json2csv   from 'json2csv'
import config from  '../../../config';

import Select   from 'react-select'
  import {prepareSelectOptionsList,filterFocusAreaOptions, filterFocusAreaSelectedOptions} from 'util/Utils';
 const allReportFieldList = [

     {label: 'Type', value:'Type'},
     {label: 'Number', value:'PickupNumber'},
     {label: 'Service Date',  value: (row, field) => {

         return  moment(row.ServiceStartTime).format('MM-DD-YYYY')

     }},
     {label: 'Time', value:  (row, field) =>{
            if (row.TimeWindow &&  row.Type) {
                var foundItem = _.find(config.services.timeWindowOptions, {value: row.TimeWindow})
                return foundItem ? foundItem.label : row.TimeWindow;
            } else{
                return ''
            }
    }},

     {label: 'Status ',  value:   'Status' },
     {label: 'Location', value:'MarketName'},
     {label: 'Size',  value:  (row, field) =>{
         if (row.Size &&  row.Type) {
             var foundItem = _.find(config.services[row.Type.toLowerCase()].sizeOptions, {value: row.Size})
             return foundItem ? foundItem.internalLabel : row.Size;
         }else{
             return ''
         }
     } },
     {label: 'Create Date',  value: (row, field) => {

         return  moment(row.createdAt).format('MM-DD-YYYY')

     }},
     {label: 'Promo Code Used', value:'ServiceCustomData.UserPromoCode'},
     {label: 'Seller Email', value:'UserID.email'},
     {label: 'Seller Payout', value:'SellerID.Payout'},
     {label: 'Seller Display Name', value:'SellerID.DisplayName'},
     {label: 'Seller Phone Number', value:'SellerID.PhoneNumber.Number'},
    {label: 'Seller Pickup', value:'SellerPickupNumber'},
     {label: 'Products #', value:'TotalProductsNumber'},
     // {label: 'Notifications ',  value:  (row, field) =>{
     //    return JSON.stringify(_.get(row, 'Notifications', []))
     // } },
     // {label: 'Change log ',  value:  (row, field) =>{
     //     return JSON.stringify(_.get(row, 'ChangeLog', []))
     // } },
     {label: 'Service Area', value:'ServiceAreaName'},
     {label: 'Pickup Address',  value: (row, field) => {
         return _.get(row.PickupAddress, 'Street', '')+ ' ' + _.get(row.PickupAddress, 'City', '')+ ' ' +  _.get(row.PickupAddress, 'Zip', '')
     }},
     {label: 'Status changes',  value: (row, field) => {
         var StatusChanges =_.map(_.filter(_.get(row, 'ChangeLog',[]), item=>{
             return item.FieldChanged == 'Status'
         }), item=>{
               return moment(item.createdAt).format('MM/DD')+ ' ' + item.From + ' >> ' + item.To
         })
         if (_.size(StatusChanges)>0) {
             return StatusChanges.join('\n')
         }
     }},
     {label: 'Calendar URL',  value: (row, field) => {
         if (_.get(row, 'CalendarEvent.CalendarEventLink')) {
             return _.get(row, 'CalendarEvent.CalendarEventLink')
         }
     }},

]

export default class AdminServicesActionsBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);


        this.state = {
             pending: false,
            reportFields:allReportFieldList
         };

    };




    downloadReport(){
         var methodData = {
            "endpoint": "/create-report",
            'type':'post',
             'not_display_success_message':true,
             overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
         this.props.makeRequest({'records': this.props.adminServices.selectedRecords, reportType:'services' }, methodData).then(res => {
           var fields = _.map(this.state.reportFields, function (field) {
                return _.extend({}, field, {default: ''});
           })
             var csvData = json2csv.parse(res.data, {
                 fields: fields,
              })

               var filename = "report_" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
               var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
               if (navigator.msSaveBlob) { // IE 10+
                   navigator.msSaveBlob(blob, filename);
               } else {
                   var link = document.createElement("a");
                   if (link.download !== undefined) { // feature detection
                       // Browsers that support HTML5 download attribute
                       var url = URL.createObjectURL(blob);
                       link.setAttribute("href", url);
                       link.setAttribute("download", filename);
                       link.style.visibility = 'hidden';
                       document.body.appendChild(link);
                       link.click();
                       document.body.removeChild(link);
                   }
               }

        }).catch(err => {
            console.log('err', err );
        });
    }
    handleDownloadComplete(){
        console.log(' handleDownloadComplete',true );
        this.setState({'downloadReport':false});
    }
    onSelectTab(event){
         this.setState({displayReportTab:!this.state.displayReportTab})
    }
    render() {

        // if (_.size(self.state.filterOptions.ageGroup) >0 ){
        //     ageRanges.unshift({value: false, label: 'All groups'});
        //  }
        return (
            <div className="action-block">
                <Tabs defaultActiveKey={''} onSelect={(e)=>{this.onSelectTab(e)}} id="sellerActionBox" >

                        <Tab eventKey={'reports'}  unmountOnExit={true} title="Reports" >
                            <Row className= {this.state.displayReportTab ? '':'hidden'}>
                                <Col md={4} xs={4} className="top10">
                                    <Select
                                        tabIndex="0"
                                        searchable ={true}
                                        multi
                                        selectedOptions
                                        clearable={false}
                                        placeholder="Included fields"
                                        options={allReportFieldList}
                                        onChange={ (selectedOptions)=> this.setState({'reportFields': selectedOptions})}
                                        //  filterOptions={filterOptions}
                                        value={this.state.reportFields}
                                    />
                                </Col>

                            </Row>
                            <Row>

                                <Col md={3} xs={6} className="top10">
                                     <button className="btn btn-primary" disabled={this.state.pending} onClick={ this.downloadReport.bind(this)}
                                            type="button">
                                        Download report
                                    </button>



                                </Col>
                            </Row>
                        </Tab>

                    </Tabs>

                </div >
        );

    }
}



